<template>
  <div v-if="track" class="py-3">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="form-group track-lyrics-container" v-if="track.lyrics">
          <p><span v-html="lyricsHtml"></span></p>
        </div>

        <div class="alert alert-dark" v-if="!track.lyrics">
          This track has no lyrics.
        </div>
      </div>
    </div>

    <div class="pt-4">
      <textarea
        class="d-none track-lyrics"
        rows="8"
        v-model="track.lyrics"
      ></textarea>

      <a
        href="#"
        class="btn btn-raised btn-lg font-weight-semibold copy-track-lyrics-button"
        v-bind:class="{ 'btn-success': copied, 'btn-info': !copied }"
        data-clipboard-action="copy"
        data-clipboard-target=".track-lyrics"
      >
        <span v-if="!copied">Copy to clipboard</span>
        <span v-if="copied">Copied</span>
      </a>

      <a
        href="#"
        data-dismiss="modal"
        aria-label="Close"
        class="btn btn-raised btn-danger btn-lg font-weight-semibold"
      >
        Close
      </a>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Clipboard from "clipboard";
import { playerService } from "../player-service";

export default Vue.component("track-lyrics", {
  data: function () {
    return {
      track: null,
      copied: false,
      clipboardPlugin: null,
      lyricsHtml: null,
    };
  },

  mounted: function () {
    playerService.$on("open-track-lyrics", (track) => {
      // Update curr track for modal + reset selected project.
      this.track = track;
      this.lyricsHtml = this.track.lyrics;

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#trackLyricsModal");

      this.reset();
    });
  },

  methods: {
    copy: function () {
      this.copied = true;
    },

    reset: function () {
      let ctx = this;

      // Always start from the original lyrics to avoid nested highlights
      this.lyricsHtml = this.track.lyrics;

      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }

      // Lyrics highlighting logic (only when search exists)
      if (playerService.getLs("search")) {
        let searchHistory = JSON.parse(playerService.getLs("search"));
        let searchString = searchHistory[0].name.trim();
        let isDoubleQuoted =
          searchString.startsWith('"') && searchString.endsWith('"');

        if (isDoubleQuoted) {
          // Exact phrase search
          let phrase = searchString.slice(1, -1);
          if (phrase.includes("'")) {
            // If phrase contains apostrophe, highlight both versions
            let queryWithApostrophe = new RegExp(
              "\\b" + escapeRegExp(phrase) + "\\b",
              "ig",
            );
            let queryWithoutApostrophe = new RegExp(
              "\\b" + escapeRegExp(phrase.replace(/'/g, "")) + "\\b",
              "ig",
            );

            // First highlight version with apostrophe
            this.lyricsHtml = this.lyricsHtml.replace(
              queryWithApostrophe,
              '<span class="in-search">$&</span>',
            );
            // Then highlight version without apostrophe
            this.lyricsHtml = this.lyricsHtml.replace(
              queryWithoutApostrophe,
              '<span class="in-search">$&</span>',
            );
          } else {
            // No apostrophe, just do regular phrase highlight
            let query = new RegExp("\\b" + escapeRegExp(phrase) + "\\b", "ig");
            this.lyricsHtml = this.lyricsHtml.replace(
              query,
              '<span class="in-search">$&</span>',
            );
          }
        } else {
          // Individual word search
          let searchValues = searchString.split(" ");
          for (let searchValue of searchValues) {
            if (searchValue.includes("'")) {
              // If word contains apostrophe, highlight both versions
              let queryWithApostrophe = new RegExp(
                "\\b" + escapeRegExp(searchValue) + "\\b",
                "ig",
              );
              let queryWithoutApostrophe = new RegExp(
                "\\b" + escapeRegExp(searchValue.replace(/'/g, "")) + "\\b",
                "ig",
              );

              // First highlight version with apostrophe
              this.lyricsHtml = this.lyricsHtml.replace(
                queryWithApostrophe,
                '<span class="in-search">$&</span>',
              );
              // Then highlight version without apostrophe
              this.lyricsHtml = this.lyricsHtml.replace(
                queryWithoutApostrophe,
                '<span class="in-search">$&</span>',
              );
            } else {
              // No apostrophe, just do regular word highlight
              let query = new RegExp(
                "\\b" + escapeRegExp(searchValue) + "\\b",
                "ig",
              );
              this.lyricsHtml = this.lyricsHtml.replace(
                query,
                '<span class="in-search">$&</span>',
              );
            }
          }
        }

        setTimeout(function () {
          $(".track-lyrics-container").animate(
            {
              scrollTop: $(".in-search:first").offset().top - 155,
            },
            300,
          );
        }, 500);
      }

      if (this.clipboardPlugin) {
        this.clipboardPlugin.destroy();
      }

      this.clipboardPlugin = new Clipboard(".copy-track-lyrics-button", {
        container: document.getElementById("trackLyricsModal"),
        text: function (trigger) {
          return ctx.track.lyrics;
        },
      });

      this.copied = false;

      this.clipboardPlugin.on("success", function (e) {
        ctx.copied = true;
        e.clearSelection();
      });

      $("#trackLyricsModal").on("hide.bs.modal", function (e) {
        $(".track-lyrics-container").scrollTop(0);
      });
    },
  },
});
</script>
